import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperNavigationInterface, SwiperAutoplayInterface } from 'ngx-swiper-wrapper';
import { OvsComponent } from '../../shared/core/ovs.core';
import { ResortDetail, ResortInventory } from '../../models/presentation.model';
import { ResortInventoryGroup } from '../../models/browser.model';
import { ResortComponent } from '../../shared/resort.component';
import { ResortInsightsService } from '../../instrumentation/resort-insights.service';
import { ResortDetailsPageEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
  selector: 'availability-carousel',
  templateUrl: './availability-carousel.component.html',
  styleUrls: ['./availability-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AvailabilityCarouselComponent extends ResortComponent
{
    @Input()
    public group: ResortInventoryGroup;
    @Output()
    public book: EventEmitter<ResortInventory> = new EventEmitter<ResortInventory>();
    private _swiper: any;
    @ViewChild("swiper")
    private _swiperElementRef: ElementRef;

    public ngAfterViewInit(): void {
        let element: any = this._swiperElementRef.nativeElement;
        const swipeConfig: SwiperConfigInterface = {
            direction: 'horizontal', 
            loop: false, 
            slidesPerView: 'auto', 
            autoplay: false,
            navigation: {
                nextEl: '.availability-carousel__btn--next',
                prevEl: '.availability-carousel__btn--prev',
            },
            spaceBetween: 15,
        };
        this._swiper = new Swiper(element, swipeConfig);
    }

    public onBook(inventory: ResortInventory): void
    {
        this.book.next(inventory);
    }

    public swipe():void{
        UserActivityLogger.logEvent(ResortDetailsPageEvents.CarouselArrowClicked,{}, UserActivityLoggerOptions.AppInsightsOnly);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-availability/availability-carousel.component.ts